// The Hub's name as staff see it. A rename happens here and nowhere else:
// the pages import it, and web/vite.config.ts writes it into the HTML files.
export const HUB_NAME = 'Technology Hub';
